// extracted by mini-css-extract-plugin
module.exports = {"freeLabel":"promo-label_freeLabel__bk806"};